@if (file.type == 'UPLOADED_FILE') {
	<div class="document">
		<div class="file-row">
			<div class="document-name" style="display: inline;">{{ file.fileName }}</div>
			@if (!isDeleted(file)) {
				<div>
					@if (!isDeleted(file)) {
						<div class="created">uploaded on {{ adjustTimestamp(file.uploadTimestamp) | localizedDate | async }}</div>
					}
					<div class="created">by {{ file.uploadAuthor.firstName + ' ' + file.uploadAuthor.lastName }}</div>
				</div>
			}
			@if (isDeleted(file)) {
				<div>
					@if (isDeleted(file)) {
						<div class="created">deleted on {{ adjustTimestamp(file.deletionTimestamp) | localizedDate | async }}</div>
					}
					<div class="created">by {{ file.deletionAuthor.firstName + ' ' + file.deletionAuthor.lastName }}</div>
				</div>
			}
		</div>
		@if (!blockInputs && !isDeleted(file)) {
			<nb-icon class="delete-icon" icon="close-outline" (click)="openPopover()" [nbPopover]="popover" nbPopoverTrigger="noop" nbPopoverPlacement="right" [nbPopoverContext]=""></nb-icon>
		}
		@if (!isDeleted(file)) {
			<nb-icon class="document-link" icon="download-outline" (click)="download(file.fileUuid)"></nb-icon>
		}
	</div>
}
@if (file.type == 'ACTIVE_ORDER') {
	<div class="document">
		<div>
			<div class="document-name">{{ getDocumentName(file) }}</div>
			<div class="created">signed on {{ adjustTimestamp(file.uploadTimestamp) | localizedDate | async }}</div>
		</div>
		<nb-icon class="document-link" icon="download-outline" (click)="download(file.fileUuid)"></nb-icon>
	</div>
}
@if (file.type == 'AR_CHECKLIST') {
	<div class="document">
		<div>
			<div class="document-name">{{ file.fileName.split('.')[0] }}</div>
			<div class="created">created on {{ adjustTimestamp(file.uploadTimestamp) | localizedDate | async }}</div>
		</div>
		<nb-icon class="document-link" icon="external-link-outline" (click)="openInNewTab(file.fileUuid)"></nb-icon>
	</div>
}

<ng-template #popover>
	<div class="delete-popover" click-outside (clickOutside)="this.closePopoverIfClickedOutside($event)">
		<h6>DELETE FILE</h6>
		<div>This action will permanently delete the file</div>

		<div class="buttons">
			<button nbButton outline status="warning" size="tiny" class="cancel-button" (click)="closePopover()">CANCEL</button>
			<button nbButton status="warning" size="tiny" (click)="delete()">DELETE</button>
		</div>
	</div>
</ng-template>
